export const NONE = 'NONE';
export const LOW = 'LOW';
export const MEDIUM = 'MEDIUM';
export const HIGH = 'HIGH';
export const TaskPriorityKeys = {
  NONE,
  LOW,
  MEDIUM,
  HIGH
};
export const TaskPriorityKeysList = [NONE, LOW, MEDIUM, HIGH];